module.exports = __webpack_public_path__ + "static/media/slide-6.79c2e0a8.png";